export function cx(...parts) {
  return parts
    .flatMap((p) => {
      if (!p) return [];
      if (Array.isArray(p)) return p;
      if (typeof p === 'object') {
        return Object.entries(p)
          .filter(([, v]) => Boolean(v))
          .map(([k]) => k);
      }
      return [String(p)];
    })
    .filter(Boolean)
    .join(' ');
}
